import { IClassification, IImmigrationStatus, IImmigrationStatusInfo } from 'src/shared/types/ImmigrationStatus';
import { createApiFetcher } from 'src/utils/ApiUtils';

const fetchData = createApiFetcher('immigrationstatus/');

export const getImmigrationStatusInfo = async (
  beneId: number | undefined,
  dependentId: number | undefined
): Promise<IImmigrationStatusInfo[]> =>
  fetchData<IImmigrationStatusInfo[]>(`info?beneId=${beneId ?? ''}&dependentId=${dependentId ?? ''}`);

export const getImmigrationStatusList = async (): Promise<IImmigrationStatus[]> =>
  fetchData<IImmigrationStatus[]>(`list`);

export const getImmigrationStatusClassification = async (
  countryCode: string,
  activeClassification: boolean
): Promise<IClassification[]> =>
  fetchData<IClassification[]>(
    `classification?countryCode=${countryCode}&activeClassification=${activeClassification}`
  );
